export default "__VITE_ASSET__BKOKjQef__"